import { RelatorioConsultaPagamentoModel } from '@/models/administracao/consulta-pagamento/RelatorioConsultaPagamentoModel';
import { integracaoRelatoriosGerenciaisApi } from '@/api/RelatoriosGerenciaisApi';
import { PaginationModel } from '@/models/commons/PaginationModel';
import { ControllerRelatorioConsultaPagamento } from '@/api/gerencial/RequestRelatorioConsultaPagamentoDTO';

export default class GerencialConsultaPagamentoService {

    static gerarRelatorio(
        tipo: string, 
        request: RelatorioConsultaPagamentoModel
    ) {
        return integracaoRelatoriosGerenciaisApi.gerarRelatorioConsultaPagamento(tipo, ControllerRelatorioConsultaPagamento.convertToDTO(request));
    }

    static consultar(
        request: RelatorioConsultaPagamentoModel,
        options: PaginationModel,
    ) {
        return integracaoRelatoriosGerenciaisApi.gerarConsultaPagamento(ControllerRelatorioConsultaPagamento.convertToFiltroDTO(request, options));
    }
}